/* eslint-disable react/style-prop-object */
import trans from "../../../utils";
import Searchbar from "../../Helpers/Searchbar/Searchbar";

export default function DispatcherPlansHead({ value, onChange, rightSlot }) {
	return (
		<div className="bg-white p-16 d-flex align-items-center gap-3">
			<Searchbar
				style="search search-dark input-group"
				path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
				placeholder={trans("Search")}
				value={value}
				onChange={(e) => onChange(e.target.value)}
			/>
			{rightSlot && (
				<div className="ms-auto d-flex align-items-center gap-3">
					{rightSlot}
				</div>
			)}
		</div>
	);
}
